export default function DepreciationSection() {
  return (
    <section id="depreciation" className="py-24 bg-[#f8f5f0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Content */}
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-[#f97316]/15 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
              <i className="ri-information-line"></i>
              Why Depreciation Matters
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-[#1a1a2e] leading-tight mb-5">
              Your Insurance Company Isn&apos;t Hiding Money — But They&apos;re Not Telling You About It Either
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              When your insurance company pays out a roofing claim, they typically issue two checks. The first is the <strong className="text-[#1a1a2e]">Actual Cash Value (ACV)</strong> — the depreciated value of your old roof. The second, larger check is the <strong className="text-[#1a1a2e]">Recoverable Depreciation</strong> — and it only gets released after you complete the repairs and submit documentation.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Most homeowners never know this second check exists. They use savings, credit cards, or money from other household funds to cover what they think is a gap — when in reality, that money was already set aside for them.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                "Recoverable depreciation exists on 98% of all roofing claims",
                "The average unclaimed holdback is $8,000–$15,000",
                "You must complete repairs and submit proof to receive it",
                "Most contractors never explain this process to homeowners",
                "The window to claim depreciation is typically 6–12 months",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#f97316] text-lg"></i>
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>

            <a
              href="#cta"
              className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-7 py-3.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              Find Out How Much You&apos;re Owed
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Right Stats */}
          <div className="flex-shrink-0 w-full lg:w-96 flex flex-col gap-6">
            <div className="bg-white rounded-2xl p-8 border border-gray-100">
              <div className="text-5xl font-black text-[#f97316] mb-2">$12,847</div>
              <div className="text-[#1a1a2e] font-bold text-base mb-1">Average Unclaimed Depreciation</div>
              <div className="text-gray-500 text-sm">Per residential roofing claim in the US</div>
            </div>
            <div className="bg-[#1a1a2e] rounded-2xl p-8">
              <div className="text-5xl font-black text-[#f97316] mb-2">2 Checks</div>
              <div className="text-white font-bold text-base mb-1">Every Insurance Claim Pays Out</div>
              <div className="text-white/60 text-sm">Most homeowners only know about the first one</div>
            </div>
            <div className="bg-white rounded-2xl p-8 border border-gray-100">
              <div className="text-5xl font-black text-[#1a1a2e] mb-2">6–12 mo</div>
              <div className="text-[#1a1a2e] font-bold text-base mb-1">Window to Claim Depreciation</div>
              <div className="text-gray-500 text-sm">After this deadline, the money is gone forever</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
